<template>
  <div class="change-meet-page">
    <chooseMeet
      @confirm="confirmsub"
      @cancel="cancel"
      idType="mid"
      :hasChecked="hasChecked"
    />
  </div>
</template>
<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import chooseMeet from './components/chooseMeet.vue'
import { useRouter } from 'vue-router'
import api from '@/api'
const router = useRouter()
const store = useStore()

const ExhCode = computed(() => store.state.ExhCode)
const token = computed(() => store.state.token)
const VisitorID = computed(() => store.state.VisitorID)
const openid = computed(() => store.state.openid)

const hasChecked = ref([])
if (sessionStorage.getItem('activitys')) {
  const Activitys = JSON.parse(sessionStorage.getItem('activitys'))
  hasChecked.value = Activitys.map((item) => item.ActivitysID)
}

const updatevisitor = () => {
  const params = {    
    exhCode: ExhCode.value,
    VisitorID: VisitorID.value,
    field1: '参会'
  }
  api.updateField(params).then((res) => {
  })
}

const confirmsub = (data) => {
updatevisitor()
  let payType = '无需支付'
  const params = {
    exhCode: ExhCode.value,
    token: token.value,
    ticketList: null,
    payType: payType,
    visitorID: VisitorID.value,
    openID: openid.value,
    ReturnSuccessUrl: '',
    ReturnFailUrl: window.location.href,
    activityIDs: data.map((item) => item.mid),
    invitecode: ''
  }
  console.log(JSON.stringify(params))
  api.SubmitActivityPayOrderApi(params).then((res) => {
    if (res.code === 200) {
      router.go(-1)
    }
  })
}

const cancel = () => {
  router.push({ path: '/success' })
}
</script>

<style lang="less" scoped>
.change-meet-page {
  .page-title {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    padding: 15px 0;
    margin: 0;
    background-color: #fff;
  }
}
</style>
